import { Form } from "@redriver/cinnamon-mui";
import { getResources } from "./actions";

const ResourceTypeAhead = ({ clientId, ...props }) => (
  <Form.TypeAhead {...props} lookupAction={getResources} />
);

export default ResourceTypeAhead;
